import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProLayout from '../layout/ProLayout';
import ProGiftCardModal from '../modals/ProGiftCardModal';

const GiftCardPage = () => {
  const navigate = useNavigate();

  return (
    <ProLayout title="Carte cadeau">
      <div className="modal-as-page h-full">
        <ProGiftCardModal
          isOpen={true}
          onClose={() => navigate('/optician-dashboard')}
          onSuccess={() => navigate('/optician-dashboard')}
        />
      </div>
    </ProLayout>
  );
};

export default GiftCardPage;
